import Highcharts from 'highcharts';

export const createDefaultXAxisOptions = (
): Highcharts.XAxisOptions => ({
  type: 'datetime',
  tickLength: 5,
  tickWidth: 1,
  lineColor: '#eceff2',
  gridLineColor: '#eceff2',
});
